export enum UsersApiActions {
  LoadUsersSuccess = '[Users API] Load Users Success',
  LoadUsersFailure = '[Users API] Load Users Failure',

  LoadBrokersByT2CodeSuccess = '[Users API] Load Brokers By T2Code Success',
  LoadBrokersByT2CodeFailure = '[Users API] Load Brokers By T2Code Failure',

  LoadClientBrokersSuccess = '[Users API] Load Client Brokers Success',
  LoadClientBrokersFailure = '[Users API] Load Client Brokers Failure',

  LoadAuthenticatedUserSuccess = '[Users API] Load Authenticated User Success',
  LoadAuthenticatedUserFailure = '[Users API] Load Authenticated User Failure',

  LoadUserSuccess = '[Users API] Load User Success',
  LoadUserFailure = '[Users API] Load User Failure',

  AddSuccess = '[Users API] Add User Success]',
  AddFailure = '[Users API] Add User Failure]',

  UpdateSuccess = '[Users API] Update User Success]',
  UpdateFailure = '[Users API] Update User Failure]',

  AddBrokerSuccess = '[Users API] Add Broker Success]',
  AddBrokerFailure = '[Users API] Add Broker Failure]',

  UpdateBrokerSuccess = '[Users API] Update Broker Success]',
  UpdateBrokerFailure = '[Users API] Update Broker Failure]',

  UserEnabledSuccess = '[Users API] User Enabled Success',
  UserEnabledFailure = '[Users API] User Enabled Failure',

  UserDeletedSuccess = '[Users API] User Deleted Success',
  UserDeletedFailure = '[Users API] User Deleted Failure',

  UpdateLanguageSuccess = '[Users API] Update Language Success',
  UpdateLanguageFailure = '[Users API] Update Language Failure',
}
